import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    aboutDocument:
      'Banking regulations require us to ask you for proof of funds.',
    recommended: 'Recommended',
    title: 'Add proof of funds',
    types: {
      bankStatement: 'Bank or savings account statement',
      loanCertificate: 'Certificate of loan from a financial institution',
      paySlip: 'Pay slip',
    },
  },
  fr: {
    aboutDocument:
      'La réglementation bancaire nous impose de vous demander une preuve de fonds.',
    recommended: 'Recommandé',
    title: 'Ajoutez une preuve de fonds',
    types: {
      bankStatement: 'Relevé de compte bancaire ou épargne',
      loanCertificate: 'Attestation de prêt d’un organisme financier',
      paySlip: 'Bulletin de paie',
    },
  },
} as const);
